import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { PlaybooksActionDefinitionInput } from 'src/app/models/componentInputs/playbookActionInput.interface';
import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';
import { ActionStatus } from 'src/app/services/httpServices/actionsHttpService/actions-http-service.service';

@Component({
  selector: 'app-set-action-status-action',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatRadioModule, LabelsProviderPipe],
  templateUrl: './set-action-status-action.component.html',
  styleUrl: './set-action-status-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetActionStatusActionComponent {
  public fg = input.required<UntypedFormGroup>();
  public playbooksActionInput = input.required<PlaybooksActionDefinitionInput>();
  public triggerType = input.required<TriggerTypes>();
  public actionStatus = model<ActionStatus>(ActionStatus.enabled);

  public readonly actionStatusEnum = ActionStatus;

  public onRadioButtonChange(value: ActionStatus) {
    this.actionStatus.set(value);
  }
}
